// extracted by mini-css-extract-plugin
export var active = "_2b-9";
export var backButton = "_2b-8";
export var clone = "_2b-e";
export var collapseBar = "_2b-k";
export var collapseMode = "_2b-m";
export var collapsed = "_2b-o";
export var dimmed = "_2b-i";
export var dragHandle = "_2b-c";
export var dropdownIcon = "_2b-g";
export var expanding = "_2b-n";
export var hidden = "_2b-x";
export var iconContainer = "_2b-q";
export var iconSwapper = "_2b-w";
export var navItem = "_2b-6";
export var navItemIcon = "_2b-f";
export var navProfile = "_2b-7";
export var notificationCountBadge = "_2b-j";
export var notificationDot = "_2b-r";
export var optionsContainer = "_2b-h";
export var primaryNav = "_2b-0";
export var primaryNavDivider = "_2b-v";
export var primaryNavResizeHandle = "_2b-2";
export var primaryNavResizing = "_2b-1";
export var primaryNavTabSection = "_2b-u";
export var primaryTab = "_2b-p";
export var primaryTabIconBox = "_2b-s";
export var secondaryNav = "_2b-3";
export var selected = "_2b-t";
export var settingsNav = "_2b-4";
export var settingsNavItems = "_2b-5";
export var show = "_2b-d";
export var sideNav = "_2b-l";
export var teamItem = "_2b-a";
export var userProfileItem = "_2b-b";